
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TermAcceptanceService, TermAcceptanceDto } from '../term-acceptance.service';

@Component({
    selector: 'app-term-acceptance-detail',
    templateUrl: './term-acceptance-detail.component.html',
    standalone: false
})
export class TermAcceptanceDetailComponent implements OnInit {
    item: TermAcceptanceDto | null = null;
    auditTrail: any = null;
    loading = false;

    constructor(
        private route: ActivatedRoute,
        private service: TermAcceptanceService
    ) { }

    ngOnInit(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.load(id);
        }
    }

    load(id: string): void {
        this.loading = true;
        this.service.getAceiteById(id).subscribe({
            next: (res) => {
                this.item = res;
                this.loadAudit(id);
            },
            error: (err) => {
                console.error('Error loading detail', err);
                this.loading = false;
            }
        });
    }

    loadAudit(id: string): void {
        this.service.getAuditTrail(id).subscribe({
            next: (res) => {
                this.auditTrail = res;
                this.loading = false;
            },
            error: (err) => {
                console.error('Error loading audit log', err);
                this.loading = false;
            }
        });
    }
}
